import { Helper } from '../../Helper';
export class GetArrayIndexHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.unwrapArray);
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'GT');
            },
            whenTrue: () => {
                sb.emitOp(node, 'PICKITEM');
            },
            whenFalse: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitHelper(node, options, sb.helpers.wrapUndefined);
            },
        }));
    }
}

//# sourceMappingURL=GetArrayIndexHelper.js.map
